(window.FoxTheme = window.FoxTheme || {}),
    (FoxTheme.config = {
        hasLocalStorage: !1,
        mqlMobile: !1,
        mqlTablet: !1,
        mediaQueryMobile: "screen and (max-width: 767px)",
        mediaQueryTablet: "screen and (max-width: 1023px)",
        motionReduced: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
        isTouch: "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,
        isRTL: "rtl" === document.documentElement.getAttribute("dir"),
    }),
    console.log("%c" + window.FoxTheme.settings.themeName + " theme (v" + window.FoxTheme.settings.themeVersion + ") by Foxecom | Learn more https://foxecom.com/products/sleek-shopify-theme", "font-size: 14px; color: #FF5C00;"),
    (function () {
        try {
            let e = "sleek:test";
            window.localStorage.setItem(e, "test"), window.localStorage.removeItem(e), (FoxTheme.config.hasLocalStorage = !0);
        } catch (t) {}
        (FoxTheme.DOMready = function (e) {
            "loading" != document.readyState ? e() : document.addEventListener("DOMContentLoaded", e);
        }),
            (FoxTheme.a11y = {
                trapFocusHandlers: {},
                getFocusableElements: (e) =>
                    Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe")),
                trapFocus(e, t = e) {
                    var i = FoxTheme.a11y.getFocusableElements(e),
                        s = i[0],
                        a = i[i.length - 1];
                    FoxTheme.a11y.removeTrapFocus(),
                        (FoxTheme.a11y.trapFocusHandlers.focusin = (t) => {
                            (t.target === e || t.target === a || t.target === s) && document.addEventListener("keydown", FoxTheme.a11y.trapFocusHandlers.keydown);
                        }),
                        (FoxTheme.a11y.trapFocusHandlers.focusout = function () {
                            document.removeEventListener("keydown", FoxTheme.a11y.trapFocusHandlers.keydown);
                        }),
                        (FoxTheme.a11y.trapFocusHandlers.keydown = function (t) {
                            "TAB" === t.code.toUpperCase() && (t.target !== a || t.shiftKey || (t.preventDefault(), s.focus()), (t.target === e || t.target === s) && t.shiftKey && (t.preventDefault(), a.focus()));
                        }),
                        document.addEventListener("focusout", FoxTheme.a11y.trapFocusHandlers.focusout),
                        document.addEventListener("focusin", FoxTheme.a11y.trapFocusHandlers.focusin),
                        t.focus(),
                        "INPUT" === t.tagName && ["search", "text", "email", "url"].includes(t.type) && t.value && t.setSelectionRange(0, t.value.length);
                },
                removeTrapFocus(e = null) {
                    document.removeEventListener("focusin", FoxTheme.a11y.trapFocusHandlers.focusin),
                        document.removeEventListener("focusout", FoxTheme.a11y.trapFocusHandlers.focusout),
                        document.removeEventListener("keydown", FoxTheme.a11y.trapFocusHandlers.keydown),
                        e && e.focus();
                },
            }),
            (FoxTheme.utils = {
                throttle: (e) => {
                    let t = null,
                        i,
                        s = (s) => () => {
                            (t = null), e.apply(s, i);
                        },
                        a = (...e) => {
                            (i = e), null === t && (t = requestAnimationFrame(s(this)));
                        };
                    return (
                        (a.cancel = () => {
                            cancelAnimationFrame(t), (t = null);
                        }),
                        a
                    );
                },
                setScrollbarWidth() {
                    let e = window.innerWidth - document.body.clientWidth;
                    e > 0 && document.documentElement.style.setProperty("--scrollbar-width", `${e}px`);
                },
                waitForEvent: (e, t) =>
                    new Promise((i) => {
                        let s = (a) => {
                            a.target === e && (e.removeEventListener(t, s), i(a));
                        };
                        e.addEventListener(t, s);
                    }),
                queryDomNodes(e = {}, t = document) {
                    let i = Object.entries(e).reduce((e, [i, s]) => {
                        let a = "string" == typeof s,
                            n = a ? s : s[0];
                        return (e[i] = t && t[a ? "querySelector" : "querySelectorAll"](n)), !a && e[i] && (e[i] = [...e[i]]), e;
                    }, {});
                    return i;
                },
                addEventDelegate({ context: e = document.documentElement, event: t = "click", selector: i, handler: s, capture: a = !1 }) {
                    let n = function (e) {
                        for (let t = e.target; t && t !== this; t = t.parentNode)
                            if (t.matches(i)) {
                                s.call(t, e, t);
                                break;
                            }
                    };
                    return (
                        e.addEventListener(t, n, a),
                        () => {
                            e.removeEventListener(t, n, a);
                        }
                    );
                },
                getSectionId: (e) => (e.hasAttribute("data-section-id") ? e.dataset.sectionId : (e.classList.contains("shopify-section") || (e = e.closest(".shopify-section")), e.id.replace("shopify-section-", ""))),
                debounce: (e, t) => {
                    let i;
                    return (...s) => {
                        clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
                    };
                },
                fetchConfig: (e = "json") => ({ method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${e}` } }),
                setStorage(e, t, i) {
                    if (!FoxTheme.config.hasLocalStorage) return;
                    let s = new Date(),
                        a = { value: t, expiry: s.getTime() + 864e5 * i };
                    window.localStorage.setItem(e, JSON.stringify(a));
                },
                getStorage(e) {
                    if (!FoxTheme.config.hasLocalStorage) return null;
                    let t = window.localStorage.getItem(e);
                    if (!t) return null;
                    let i = JSON.parse(t),
                        s = new Date();
                    return s.getTime() > i.expiry ? (window.localStorage.removeItem(e), null) : i.value;
                },
                postLink(e, t) {
                    t = t || {};
                    let i = t.method || "post",
                        s = t.parameters || {},
                        a = document.createElement("form");
                    for (let n in (a.setAttribute("method", i), a.setAttribute("action", e), s))
                        for (let r in s[n])
                            for (let o in s[n][r]) {
                                let l = document.createElement("input");
                                l.setAttribute("type", "hidden"), l.setAttribute("name", `${n}[${r}][${o}]`), l.setAttribute("value", s[n][r][o]), a.appendChild(l);
                            }
                    document.body.appendChild(a), a.submit(), document.body.removeChild(a);
                },
                imageReady: (e) =>
                    e
                        ? Promise.all(
                              (e = e instanceof Element ? [e] : Array.from(e)).map(
                                  (e) =>
                                      new Promise((t) => {
                                          ("IMG" === e.tagName && e.complete) || !e.offsetParent ? t() : (e.onload = () => t());
                                      })
                              )
                          )
                        : Promise.resolve(),
                displayedMedia: (e) =>
                    Array.from(e).find((e) => {
                        let t = window.getComputedStyle(e);
                        return "none" !== t.display;
                    }),
            }),
            (FoxTheme.pubsub = {
                PUB_SUB_EVENTS: {
                    cartUpdate: "cart-update",
                    quantityUpdate: "quantity-update",
                    quantityRules: "quantity-rules",
                    quantityBoundries: "quantity-boundries",
                    variantChange: "variant-change",
                    cartError: "cart-error",
                    facetUpdate: "facet-update",
                    optionValueSelectionChange: "option-value-selection-change",
                },
                subscribers: {},
                subscribe: (e, t) => (
                    void 0 === FoxTheme.pubsub.subscribers[e] && (FoxTheme.pubsub.subscribers[e] = []),
                    (FoxTheme.pubsub.subscribers[e] = [...FoxTheme.pubsub.subscribers[e], t]),
                    function i() {
                        FoxTheme.pubsub.subscribers[e] = FoxTheme.pubsub.subscribers[e].filter((e) => e !== t);
                    }
                ),
                publish(e, t) {
                    FoxTheme.pubsub.subscribers[e] &&
                        FoxTheme.pubsub.subscribers[e].forEach((e) => {
                            e(t);
                        });
                },
            }),
            (FoxTheme.focusVisiblePolyfill = function () {
                let e = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"],
                    t = null,
                    i = null;
                window.addEventListener("keydown", (t) => {
                    e.includes(t.code.toUpperCase()) && (i = !1);
                }),
                    window.addEventListener("mousedown", (e) => {
                        i = !0;
                    }),
                    window.addEventListener(
                        "focus",
                        () => {
                            t && t.classList.remove("focused"), i || (t = document.activeElement).classList.add("focused");
                        },
                        !0
                    );
            }),
            (FoxTheme.Carousel = class e {
                constructor(e, t, i = null) {
                    this.container = e;
                    let s = [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.Keyboard, FoxTheme.Swiper.Mousewheel];
                    i && (s = s.concat(i)), (this.options = { modules: s, ...t });
                }
                init() {
                    this.slider = new FoxTheme.Swiper.Swiper(this.container, this.options);
                }
            }),
            (FoxTheme.delayUntilInteraction = class e {
                constructor(e, t = 5e3) {
                    (this.loadScriptTimer = setTimeout(e, t)),
                        (this.userInteractionEvents = ["mouseover", "mousemove", "keydown", "touchstart", "touchend", "touchmove", "wheel"]),
                        (this.onScriptLoader = this.triggerScriptLoader.bind(this, e)),
                        this.userInteractionEvents.forEach((e) => {
                            window.addEventListener(e, this.onScriptLoader, { passive: !0 });
                        });
                }
                triggerScriptLoader(e) {
                    e(),
                        clearTimeout(this.loadScriptTimer),
                        this.userInteractionEvents.forEach((e) => {
                            window.removeEventListener(e, this.onScriptLoader, { passive: !0 });
                        });
                }
            }),
            (FoxTheme.Currency = {
                formatMoney: function e(t, i) {
                    "string" == typeof t && (t = t.replace(".", ""));
                    let s = "",
                        a = /\{\{\s*(\w+)\s*\}\}/,
                        n = i || "${{amount}}";
                    function r(e, t, i, s) {
                        if (((i = i || ","), (s = s || "."), isNaN(e) || null === e)) return 0;
                        e = (e / 100).toFixed(t);
                        let a = e.split("."),
                            n = a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
                            r = a[1] ? s + a[1] : "";
                        return n + r;
                    }
                    switch (n.match(a)[1]) {
                        case "amount":
                            s = r(t, 2);
                            break;
                        case "amount_no_decimals":
                            s = r(t, 0);
                            break;
                        case "amount_with_comma_separator":
                            s = r(t, 2, ".", ",");
                            break;
                        case "amount_no_decimals_with_comma_separator":
                            s = r(t, 0, ".", ",");
                            break;
                        case "amount_no_decimals_with_space_separator":
                            s = r(t, 0, " ");
                            break;
                        case "amount_with_apostrophe_separator":
                            s = r(t, 2, "'");
                    }
                    return n.replace(a, s);
                },
                getBaseUnit: function e(t) {
                    if (t && t.unit_price_measurement && t.unit_price_measurement.reference_value)
                        return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
                },
            }),
            new FoxTheme.delayUntilInteraction(() => {
                document.body.removeAttribute("data-initializing");
            }),
            FoxTheme.DOMready(FoxTheme.utils.setScrollbarWidth);
        let i = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        (FoxTheme.config.mqlMobile = i.matches),
            (i.onchange = (e) => {
                e.matches ? ((FoxTheme.config.mqlMobile = !0), document.dispatchEvent(new CustomEvent("matchMobile"))) : ((FoxTheme.config.mqlMobile = !1), document.dispatchEvent(new CustomEvent("unmatchMobile")));
            });
        let s = window.matchMedia(FoxTheme.config.mediaQueryTablet);
        (FoxTheme.config.mqlTablet = s.matches),
            (s.onchange = (e) => {
                e.matches ? ((FoxTheme.config.mqlTablet = !0), document.dispatchEvent(new CustomEvent("matchTablet"))) : ((FoxTheme.config.mqlTablet = !1), document.dispatchEvent(new CustomEvent("unmatchTablet")));
            });
    })();
try {
    document.querySelector(":focus-visible");
} catch (e) {
    FoxTheme.focusVisiblePolyfill();
}
function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((e) => {
        e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    }),
        document.querySelectorAll(".js-vimeo").forEach((e) => {
            e.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((e) => e.pause()),
        document.querySelectorAll("product-model").forEach((e) => {
            e.modelViewerUI && e.modelViewerUI.pause();
        });
}
class HTMLUpdateUtility {
    static viewTransition(e, t, i = [], s = []) {
        if (!e || !t) return;
        i?.forEach((e) => e(t));
        let a = document.createElement("div");
        HTMLUpdateUtility.setInnerHTML(a, t.outerHTML);
        let n = a.firstChild,
            r = Date.now();
        e.querySelectorAll("[id], [form]").forEach((e) => {
            e.id && (e.id = `${e.id}-${r}`), e.form && e.setAttribute("form", `${e.form.getAttribute("id")}-${r}`);
        }),
            e.parentNode.insertBefore(n, e),
            (e.style.display = "none"),
            s?.forEach((e) => e(n)),
            setTimeout(() => e.remove(), 500);
    }
    static setInnerHTML(e, t) {
        (e.innerHTML = t),
            e.querySelectorAll("script").forEach((e) => {
                let t = document.createElement("script");
                Array.from(e.attributes).forEach((e) => {
                    t.setAttribute(e.name, e.value);
                }),
                    t.appendChild(document.createTextNode(e.innerHTML)),
                    e.parentNode.replaceChild(t, e);
            });
    }
}
class PageTransition extends HTMLElement {
    constructor() {
        super(),
            window.addEventListener("beforeunload", () => {
                document.body.classList.add("page-loading");
            }),
            window.addEventListener("DOMContentLoaded", () => {
                FoxTheme.Motion.animate(this, { visibility: "hidden", opacity: 0 }, { duration: 1 }), document.body.classList.add("page-loaded"), document.dispatchEvent(new CustomEvent("page:loaded"));
            }),
            window.addEventListener("pageshow", (e) => {
                e.persisted && document.body.classList.remove("page-loading");
            });
    }
}
customElements.define("page-transition", PageTransition);
const clearModalComponentCount = new WeakMap();
class ModalComponent extends HTMLElement {
    constructor() {
        super(), (this.events = { handleAfterHide: "modal:handleAfterHide", handleAfterShow: "modal:handleAfterShow" }), (this.classes = { show: "modal-show", showing: "modal-showing" });
    }
    static get observedAttributes() {
        return ["id", "open"];
    }
    get isLockingNeeded() {
        return !1;
    }
    get requiresBodyAppended() {
        return !1;
    }
    get controls() {
        return Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`));
    }
    get designMode() {
        return this.hasAttribute("shopify-design-mode");
    }
    get open() {
        return this.hasAttribute("open");
    }
    get overlay() {
        return this._overlay || (this._overlay = this.querySelector(".fixed-overlay")), this._overlay;
    }
    get focusElement() {
        return this.querySelector("button");
    }
    connectedCallback() {
        if (
            ((this.abortController = new AbortController()),
            this.controls.forEach((e) => {
                e.addEventListener("click", this.onButtonClick.bind(this), { signal: this.abortController.signal });
            }),
            document.addEventListener(
                "keyup",
                (e) => {
                    "Escape" === e.code && this.hide();
                },
                { signal: this.abortController.signal }
            ),
            this.designMode && Shopify.designMode)
        ) {
            let e = this.closest(".shopify-section");
            e.addEventListener(
                "shopify:section:select",
                (e) => {
                    this.show(null, !e.detail.load);
                },
                { signal: this.abortController.signal }
            ),
                e.addEventListener(
                    "shopify:section:deselect",
                    () => {
                        this.hide();
                    },
                    { signal: this.abortController.signal }
                );
        }
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    attributeChangedCallback(e, t, i) {
        if ("open" === e) {
            if ((this.controls.forEach((e) => e.setAttribute("aria-expanded", null === i ? "false" : "true")), null === t && ("" === i || "immediate" === i))) {
                (this.hidden = !1),
                    this.removeAttribute("inert"),
                    (this.parentElementBeforeAppend = null),
                    this.requiresBodyAppended && this.parentElement !== document.body && ((this.parentElementBeforeAppend = this.parentElement), document.body.append(this));
                let s = this.handleShowTransition("immediate" !== i) || Promise.resolve();
                s.then(() => {
                    this.handleAfterShow(), this.dispatchEvent(new CustomEvent(this.events.handleAfterShow, { bubbles: !0 }));
                });
            } else if (null !== t && null === i) {
                this.setAttribute("inert", "");
                let a = this.handleHideTransition() || Promise.resolve();
                a.then(() => {
                    this.handleAfterHide(),
                        this.hasAttribute("inert") &&
                            (this.parentElement === document.body && this.parentElementBeforeAppend && (this.parentElementBeforeAppend.appendChild(this), (this.parentElementBeforeAppend = null)),
                            this.dispatchEvent(new CustomEvent(this.events.handleAfterHide, { bubbles: !0 })),
                            (this.hidden = !0));
                });
            }
            this.dispatchEvent(new CustomEvent("toggle", { bubbles: !0 }));
        }
    }
    onButtonClick(e) {
        e.preventDefault(), this.open ? this.hide() : this.show(e.currentTarget);
    }
    hide() {
        if (this.open) return this.removeAttribute("open"), FoxTheme.utils.waitForEvent(this, this.events.handleAfterHide);
    }
    show(e = null, t = !0) {
        if (this.shouleBeShow() && !this.open)
            return (
                this.prepareToShow(),
                (this.activeElement = e),
                this.setAttribute("open", t ? "" : "immediate"),
                this.isLockingNeeded && document.body.classList.add(this.classes.showing),
                FoxTheme.utils.waitForEvent(this, this.events.handleAfterShow)
            );
    }
    handleAfterHide() {
        setTimeout(() => {
            if ((FoxTheme.a11y.removeTrapFocus(this.activeElement), this.isLockingNeeded)) {
                let e = clearModalComponentCount.get(ModalComponent) - 1;
                clearModalComponentCount.set(ModalComponent, e), document.body.classList.toggle(this.classes.show, e > 0);
            }
        });
    }
    handleAfterShow() {
        if ((FoxTheme.a11y.trapFocus(this, this.focusElement), this.isLockingNeeded)) {
            let e = clearModalComponentCount.get(ModalComponent) + 1;
            clearModalComponentCount.set(ModalComponent, e), document.body.classList.remove(this.classes.showing), document.body.classList.add(this.classes.show);
        }
    }
    shouleBeShow() {
        return !0;
    }
    prepareToShow() {}
    handleShowTransition() {
        return (
            setTimeout(() => {
                this.setAttribute("active", "");
            }, 75),
            new Promise((e) => {
                this.overlay.addEventListener("transitionend", e, { once: !0 });
            })
        );
    }
    handleHideTransition() {
        return (
            this.removeAttribute("active"),
            new Promise((e) => {
                this.overlay.addEventListener("transitionend", e, { once: !0 });
            })
        );
    }
}
customElements.define("modal-component", ModalComponent), clearModalComponentCount.set(ModalComponent, 0);
class BasicModal extends ModalComponent {
    constructor() {
        super();
    }
    get isLockingNeeded() {
        return !0;
    }
    get requiresBodyAppended() {
        return !0;
    }
}
customElements.define("basic-modal", BasicModal);
class DrawerComponent extends ModalComponent {
    constructor() {
        super(), (this.events = { handleAfterHide: "drawer:handleAfterHide", handleAfterShow: "drawer:handleAfterShow" });
    }
    get isLockingNeeded() {
        return !0;
    }
    get requiresBodyAppended() {
        return !0;
    }
}
customElements.define("drawer-component", DrawerComponent);
class AccordionDetails extends HTMLDetailsElement {
    constructor() {
        super(), this.initAccordion();
    }
    initAccordion() {
        (this.isOpen = this.hasAttribute("open")),
            (this.summaryElement = this.querySelector("summary")),
            (this.contentElement = this.querySelector("summary + *")),
            this.setAttribute("aria-expanded", this.isOpen ? "true" : "false"),
            this.summaryElement.addEventListener("click", this.toggleAccordion.bind(this)),
            Shopify.designMode && this.designModeEventSetup();
    }
    static get observedAttributes() {
        return ["open"];
    }
    get open() {
        return this.isOpen;
    }
    set open(e) {
        e !== this.isOpen &&
            ((this.isOpen = e),
            this.isConnected ? this.animateAccordion(e) : e ? this.setAttribute("open", "") : this.removeAttribute("open"),
            this.setAttribute("aria-expanded", e ? "true" : "false"),
            this.setAttribute("aria-controls", this.contentElement.id),
            this.handleAfterToggle());
    }
    handleAfterToggle() {}
    toggleAccordion(e) {
        e.preventDefault(), (this.open = !this.open);
    }
    close() {
        (this.isOpen = !1), this.animateAccordion(!1);
    }
    async animateAccordion(e) {
        (this.style.overflow = "hidden"),
            e
                ? (this.setAttribute("open", ""),
                  await FoxTheme.Motion.timeline([
                      [this, { height: [`${this.summaryElement.clientHeight + 1}px`, `${this.scrollHeight + 1}px`] }, { duration: 0.25, easing: "ease" }],
                      [this.contentElement, { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.15, at: "<" }],
                  ]).finished)
                : (await FoxTheme.Motion.timeline([
                      [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
                      [this, { height: [`${this.clientHeight + 1}px`, `${this.summaryElement.clientHeight + 1}px`] }, { duration: 0.25, at: "<", easing: "ease" }],
                  ]).finished,
                  this.removeAttribute("open")),
            (this.style.height = "auto"),
            (this.style.overflow = "visible");
    }
    designModeEventSetup() {
        this.addEventListener("shopify:block:select", () => {
            this.open = !0;
        }),
            this.addEventListener("shopify:block:deselect", () => {
                this.open = !1;
            });
    }
    attributeChangedCallback(e, t, i) {
        "open" === e && this.setAttribute("aria-controls", this.contentElement.id);
    }
}
customElements.define("accordion-details", AccordionDetails, { extends: "details" });
class AccordionGroup extends AccordionDetails {
    constructor() {
        super();
    }
    handleAfterToggle() {
        if (this.isOpen) {
            let e = this.closest(".accordion-parent") || document,
                t = e.querySelectorAll('details[is="accordion-group"]');
            t.forEach((e) => {
                e !== this && (e.open = !1);
            });
        }
    }
}
customElements.define("accordion-group", AccordionGroup, { extends: "details" });
class ProgressBar extends HTMLElement {
    constructor() {
        if ((super(), this.hasAttribute("style"))) return;
        this.dataset.from && this.initProgress(), FoxTheme.Motion.inView(this, this.init.bind(this));
    }
    init() {
        this.setPercentage(this.dataset.value, this.dataset.max);
    }
    initProgress() {
        this.setPercentage(this.dataset.from, this.dataset.max);
    }
    setPercentage(e, t) {
        this.style.setProperty("--percent", `${(parseInt(e) / parseInt(t)) * 100}%`);
    }
}
customElements.define("progress-bar", ProgressBar);
class CartCount extends HTMLElement {
    constructor() {
        super();
    }
    cartUpdateUnsubscriber = void 0;
    connectedCallback() {
        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
    }
    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
    }
    get itemCount() {
        return parseInt(this.innerText);
    }
    onCartUpdate(e) {
        if (e.cart.errors) return;
        e.cart.item_count > 99 ? ((this.innerHTML = '<span class="text-sm">99+</span>'), this.classList.add("cart-count--small-medium")) : ((this.innerText = e.cart.item_count), this.classList.remove("cart-count--small-medium")),
            (this.hidden = 0 === this.itemCount);
        let t = 0 === this.itemCount ? "remove" : "add";
        document.documentElement.classList[t]("cart-has-items");
    }
}
customElements.define("cart-count", CartCount);
class QuantityInput extends HTMLElement {
    quantityUpdateUnsubscriber = void 0;
    quantityBoundriesUnsubscriber = void 0;
    quantityRulesUnsubscriber = void 0;
    constructor() {
        super();
    }
    get sectionId() {
        return this.getAttribute("data-section-id");
    }
    get productId() {
        return this.getAttribute("data-product-id");
    }
    get input() {
        return this.querySelector("input");
    }
    get value() {
        return this.input.value;
    }
    connectedCallback() {
        (this.abortController = new AbortController()),
            (this.buttons = Array.from(this.querySelectorAll("button"))),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.input.addEventListener("change", this.onInputChange.bind(this)),
            this.input.addEventListener("focus", () => setTimeout(() => this.input.select())),
            this.buttons.forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this)), { signal: this.abortController.signal }),
            this.validateQtyRules(),
            (this.quantityUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))),
            (this.quantityBoundriesUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, this.setQuantityBoundries.bind(this))),
            (this.quantityRulesUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, this.updateQuantityRules.bind(this))),
            (this.currentValue = this.value);
    }
    disconnectedCallback() {
        this.abortController.abort(),
            this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber(),
            this.quantityBoundriesUnsubscriber && this.quantityBoundriesUnsubscriber(),
            this.quantityRulesUnsubscriber && this.quantityRulesUnsubscriber();
    }
    onButtonClick(e) {
        let t = this.input.value;
        "plus" === e.currentTarget.name
            ? parseInt(this.input.getAttribute("data-min")) > parseInt(this.input.step) && 0 == this.input.value
                ? (this.input.value = this.input.getAttribute("data-min"))
                : this.input.stepUp()
            : this.input.stepDown(),
            t !== this.input.value && this.input.dispatchEvent(this.changeEvent),
            this.input.getAttribute("data-min") === t && "minus" === e.currentTarget.name && (this.input.value = parseInt(this.input.min));
    }
    onInputChange() {
        "" === this.input.value && (this.input.value = parseInt(this.input.min)),
            setTimeout(() => {
                this.validateQtyRules();
            }, 350);
    }
    validateQtyRules() {
        let e = parseInt(this.input.value);
        if (this.input.min) {
            let t = this.querySelector('button[name="minus"]');
            t && t.toggleAttribute("disabled", parseInt(e) <= parseInt(this.input.min));
        }
        if (this.input.max) {
            let i = this.querySelector('button[name="plus"]');
            i && i.toggleAttribute("disabled", parseInt(e) >= parseInt(this.input.max));
        } else {
            let s = this.querySelector('button[name="plus"]');
            s && s.removeAttribute("disabled");
        }
    }
    updateQuantityRules({ data: { sectionId: e, productId: t, parsedHTML: i } }) {
        if (e !== this.sectionId || t !== this.productId) return;
        let s = i.getElementById(`QuantityForm-${e}`),
            a = this.closest(`#QuantityForm-${e}`);
        for (let n of [".quantity__input", ".quantity__rules", ".quantity__label"]) {
            let r = a.querySelector(n),
                o = s.querySelector(n);
            if (r && o) {
                if (".quantity__input" === n) {
                    let l = ["data-cart-quantity", "data-min", "data-max", "step"];
                    for (let d of l) {
                        let c = o.getAttribute(d);
                        null !== c ? r.setAttribute(d, c) : r.removeAttribute(d);
                    }
                } else r.innerHTML = o.innerHTML;
            }
        }
    }
    setQuantityBoundries({ data: { sectionId: e, productId: t } }) {
        if (e !== this.sectionId || t !== this.productId) return;
        let i = {
                cartQuantity: this.input.hasAttribute("data-cart-quantity") ? parseInt(this.input.getAttribute("data-cart-quantity")) : 0,
                min: this.input.hasAttribute("data-min") ? parseInt(this.input.getAttribute("data-min")) : 1,
                max: this.input.hasAttribute("data-max") ? parseInt(this.input.getAttribute("data-max")) : null,
                step: this.input.hasAttribute("step") ? parseInt(this.input.getAttribute("step")) : 1,
            },
            s = i.min,
            a = null === i.max ? i.max : i.max - i.cartQuantity;
        null !== a && (s = Math.min(s, a)),
            i.cartQuantity >= i.min && (s = Math.min(s, i.step)),
            (this.input.min = s),
            a ? (this.input.max = a) : this.input.removeAttribute("max"),
            (this.input.value = s),
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate, void 0);
    }
}
customElements.define("quantity-input", QuantityInput);
class QuantitySelector extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.abortController = new AbortController()),
            (this.input = this.querySelector("input")),
            (this.buttons = Array.from(this.querySelectorAll("button"))),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.buttons.forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this)), { signal: this.abortController.signal });
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = this.input.value;
        "plus" === e.currentTarget.name ? (this.input.quantity = this.input.quantity + 1) : (this.input.quantity = this.input.quantity - 1), t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define("quantity-selector", QuantitySelector);
const onYouTubeApiLoaded = new Promise((e) => {
    window.onYouTubeIframeAPIReady = () => e();
});
class VideoElement extends HTMLElement {
    constructor() {
        super(),
            this.posterElement && this.posterElement.addEventListener("click", this.handlePosterClick.bind(this)),
            this.autoplay &&
                FoxTheme.Motion.inView(
                    this,
                    () => (
                        this.paused || this.play(),
                        () => {
                            this.pause();
                        }
                    )
                );
    }
    get posterElement() {
        return this.querySelector('[id^="DeferredPoster-"]');
    }
    get controlledElement() {
        return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
    }
    get autoplay() {
        return this.hasAttribute("autoplay");
    }
    get playing() {
        return this.hasAttribute("playing");
    }
    get player() {
        return (this.playerProxy =
            this.playerProxy ||
            new Proxy(this.initializePlayer(), {
                get: (e, t) => async () => {
                    (e = await e), this.handlePlayerAction(e, t);
                },
            }));
    }
    static get observedAttributes() {
        return ["playing"];
    }
    handlePosterClick(e) {
        e.preventDefault(), e.stopPropagation(), this.playing ? ((this.paused = !0), this.pause()) : ((this.paused = !1), this.play());
    }
    play() {
        this.playing || this.player.play();
    }
    pause() {
        this.playing && this.player.pause();
    }
    attributeChangedCallback(e, t, i) {
        if ("playing" === e) {
            if (null === t && "" === i) return this.dispatchEvent(new CustomEvent("video:play", { bubbles: !0 }));
            if (null === i) return this.dispatchEvent(new CustomEvent("video:pause", { bubbles: !0 }));
        }
    }
    initializePlayer() {
        if (this.hasAttribute("source"))
            return (
                this.setAttribute("loaded", ""),
                this.closest(".media")?.classList.remove("loading"),
                new Promise(async (e) => {
                    let t = this.querySelector("template");
                    t && t.replaceWith(t.content.firstElementChild.cloneNode(!0));
                    let i = this.hasAttribute("autoplay") || window.matchMedia("screen and (max-width: 1023px)").matches,
                        s = document.createElement("script");
                    if (((s.type = "text/javascript"), "youtube" === this.getAttribute("source"))) {
                        (window.YT && window.YT.Player) ||
                            ((s.src = "https://www.youtube.com/iframe_api"),
                            document.head.appendChild(s),
                            await new Promise((e) => {
                                s.onload = e;
                            })),
                            await onYouTubeApiLoaded;
                        let a = new YT.Player(this.querySelector("iframe"), {
                            events: {
                                onReady() {
                                    i && a.mute(), e(a);
                                },
                                onStateChange: (e) => {
                                    e.data === YT.PlayerState.PLAYING ? this.setAttribute("playing", "") : (e.data === YT.PlayerState.ENDED || e.data === YT.PlayerState.PAUSED) && this.removeAttribute("playing");
                                },
                            },
                        });
                    }
                    if ("vimeo" === this.getAttribute("source")) {
                        (window.Vimeo && window.Vimeo.Player) ||
                            ((s.src = "https://player.vimeo.com/api/player.js"),
                            document.head.appendChild(s),
                            await new Promise((e) => {
                                s.onload = e;
                            }));
                        let n = new Vimeo.Player(this.querySelector("iframe"));
                        i && n.setMuted(!0),
                            n.on("play", () => {
                                this.setAttribute("playing", "");
                            }),
                            n.on("pause", () => this.removeAttribute("playing")),
                            n.on("ended", () => this.removeAttribute("playing")),
                            e(n);
                    }
                })
            );
        {
            this.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", ""), this.closest(".media")?.classList.remove("loading");
            let e = this.querySelector("video");
            return (
                e.addEventListener("play", () => {
                    this.setAttribute("playing", ""), this.removeAttribute("suspended");
                }),
                e.addEventListener("pause", () => {
                    !e.seeking && e.paused && this.removeAttribute("playing");
                }),
                e
            );
        }
    }
    handlePlayerAction(e, t) {
        "youtube" === this.getAttribute("source")
            ? "play" === t
                ? e.playVideo()
                : e.pauseVideo()
            : "play" !== t || this.hasAttribute("source")
            ? e[t]()
            : e.play().catch((t) => {
                  if ("NotAllowedError" === t.name) {
                      this.setAttribute("suspended", ""), (e.controls = !0);
                      let i = e.previousElementSibling?.currentSrc;
                      i && (e.poster = i);
                  }
              });
    }
}
customElements.define("video-element", VideoElement);
class LocalizationForm extends HTMLElement {
    constructor() {
        super(),
            (this.elements = { input: this.querySelector('input[name="locale_code"], input[name="country_code"]'), button: this.querySelector("button"), panel: this.querySelector(".disclosure-list") }),
            this.elements.panel.removeAttribute("hidden"),
            this.elements.button.addEventListener("click", this.openSelector.bind(this)),
            this.elements.button.addEventListener("focusout", this.closeSelector.bind(this)),
            this.addEventListener("keyup", this.onContainerKeyUp.bind(this)),
            this.querySelectorAll("a").forEach((e) => e.addEventListener("click", this.onItemClick.bind(this))),
            this.handleDropdownPos();
    }
    handleDropdownPos() {
        let e = this.elements.button.getBoundingClientRect().right;
        window.innerWidth - e < 220 && this.elements.button.nextElementSibling && this.elements.button.nextElementSibling.classList.add("disclosure-list__right");
    }
    hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false"), this.removeAttribute("open");
    }
    onContainerKeyUp(e) {
        "ESCAPE" === e.code.toUpperCase() && (this.hidePanel(), this.elements.button.focus());
    }
    onItemClick(e) {
        e.preventDefault();
        let t = this.querySelector("form");
        (this.elements.input.value = e.currentTarget.dataset.value), t && t.submit();
    }
    openSelector() {
        this.elements.button.focus(), this.toggleAttribute("open"), this.elements.button.setAttribute("aria-expanded", ("false" === this.elements.button.getAttribute("aria-expanded")).toString());
    }
    closeSelector(e) {
        let t = (e.relatedTarget && "BUTTON" === e.relatedTarget.nodeName) || (e.relatedTarget && !e.relatedTarget.classList.contains("disclosure-list__option"));
        (null === e.relatedTarget || t) && this.hidePanel(t);
    }
}
customElements.define("localization-form", LocalizationForm);
class GridList extends HTMLElement {
    constructor() {
        if ((super(), FoxTheme.config.motionReduced || this.hasAttribute("motion-reduced"))) return;
        this.hideGridItems(), FoxTheme.Motion.inView(this, this.showGridItems.bind(this), { margin: "0px 0px -50px 0px" });
    }
    get gridItems() {
        return this.querySelectorAll(".f-column");
    }
    get visibleGridItems() {
        return this.querySelectorAll(".f-column:not([style])");
    }
    hideGridItems() {
        FoxTheme.Motion.animate(this.gridItems, { transform: "translateY(3.5rem)", opacity: 0.01, visibility: "hidden" }, { duration: 0 });
    }
    showGridItems() {
        FoxTheme.Motion.animate(
            this.gridItems,
            { transform: ["translateY(3.5rem)", "translateY(0)"], opacity: [0.01, 1], visibility: ["hidden", "visible"] },
            { duration: 0.5, delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1), easing: [0, 0, 0.3, 1] }
        );
    }
    reShowVisibleGridItems() {
        FoxTheme.Motion.animate(
            this.visibleGridItems,
            { transform: ["translateY(3.5rem)", "translateY(0)"], opacity: [0.01, 1], visibility: ["hidden", "visible"] },
            { duration: 0.5, delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1), easing: [0, 0, 0.3, 1] }
        );
    }
}
customElements.define("grid-list", GridList);
class AnnouncementBar extends HTMLElement {
    constructor() {
        super(), (this.announcementItemsWrapper = this.querySelector(".swiper-wrapper")), FoxTheme.Motion.inView(this, this.initializeCarousel.bind(this), { margin: "200px 0px 200px 0px" });
    }
    getNextSlideButton() {
        return this.querySelector(".swiper-button-next");
    }
    getPrevSlideButton() {
        return this.querySelector(".swiper-button-prev");
    }
    get getSlideItems() {
        return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.announcementItemsWrapper.children));
    }
    isAutoplayEnabled() {
        return this.hasAttribute("autoplay");
    }
    getAutoplaySpeed() {
        return this.hasAttribute("autoplay") ? 1e3 * parseInt(this.getAttribute("autoplay-speed")) : 5e3;
    }
    initializeCarousel() {
        this.getSlideItems.length > 1 &&
            ((this.carousel = new FoxTheme.Carousel(
                this,
                { navigation: { nextEl: this.getNextSlideButton(), prevEl: this.getPrevSlideButton() }, loop: !0, autoplay: !!this.isAutoplayEnabled() && { delay: this.getAutoplaySpeed(), pauseOnMouseEnter: !0 } },
                FoxTheme.Swiper.Autoplay
            )),
            this.carousel && this.carousel.init(),
            Shopify.designMode &&
                this.addEventListener("shopify:block:select", (e) => {
                    this.carousel.slider.slideToLoop(this.getSlideItems.indexOf(e.target));
                }));
    }
}
customElements.define("announcement-bar", AnnouncementBar);
class SelectElement extends HTMLElement {
    constructor() {
        super(), FoxTheme.Motion.inView(this, this.init.bind(this), { margin: "200px 0px 200px 0px" }), (this.select = this.querySelector("select")), this.select && this.select.addEventListener("change", this.handleSelectChange.bind(this));
    }
    init() {
        let e = window.getComputedStyle(this),
            t = this.select.options[this.select.selectedIndex].text,
            i = document.createElement("span");
        (i.style.fontFamily = e.fontFamily), (i.style.fontSize = e.fontSize), (i.style.fontWeight = e.fontWeight), (i.style.visibility = "hidden"), (i.style.position = "absolute"), (i.innerHTML = t), document.body.appendChild(i);
        let s = i.clientWidth;
        this.style.setProperty("--width", `${s}px`), i.remove();
    }
    handleSelectChange() {
        this.init();
    }
}
customElements.define("select-element", SelectElement);
class ProductBundleVariantSelector extends HTMLElement {
    constructor() {
        super(),
            (this.cssClasses = { soldOut: "f-price--sold-out", onSale: "f-price--on-sale", noCompare: "f-price--no-compare" }),
            (this.priceElement = this.querySelector(".f-price")),
            (this.variantSelect = this.querySelector("select")),
            this.variantSelect && this.variantSelect.addEventListener("change", this.handleVariantChange.bind(this));
    }
    handleVariantChange(e) {
        let t = e.target,
            i = t.options[t.selectedIndex],
            s = parseInt(i.dataset.compare_at_price || 0),
            a = parseInt(i.dataset.price || 0),
            n = "true" === i.dataset.available,
            r = "true" === t.dataset.price_varies,
            o = "true" === t.dataset.compare_at_price_varies;
        this.priceElement.classList.remove(this.cssClasses.soldOut),
            this.priceElement.classList.remove(this.cssClasses.onSale),
            this.priceElement.classList.remove(this.cssClasses.noCompare),
            n ? s > a && n && this.priceElement.classList.add(this.cssClasses.onSale) : this.priceElement.classList.add(this.cssClasses.soldOut),
            !r && o && this.priceElement.classList.add(this.cssClasses.noCompare);
        let l = this.querySelector(".f-price__regular");
        l.querySelector(".f-price-item--regular").innerHTML = `${FoxTheme.Currency.formatMoney(a, FoxTheme.settings.moneyFormat)}`;
        let d = this.querySelector(".f-price__sale");
        (d.querySelector(".f-price-item--regular").innerHTML = `<s>${FoxTheme.Currency.formatMoney(s, FoxTheme.settings.moneyFormat)}</s>`),
            (d.querySelector(".f-price-item--sale").innerHTML = `${FoxTheme.Currency.formatMoney(a, FoxTheme.settings.moneyFormat)}`);
    }
}
customElements.define("product-bundle-variant-selector", ProductBundleVariantSelector);
class ProductsBundle extends HTMLElement {
    constructor() {
        super(),
            (this.cssClasses = { hover: "is-hover", active: "is-active" }),
            (this.cartDrawerElement = document.querySelector("cart-drawer")),
            (this.addToCartButtonElement = this.querySelector("button")),
            this.addToCartButtonElement && this.addToCartButtonElement.addEventListener("click", this.handleButtonClick.bind(this)),
            (this.productBundleBlocks = this.querySelectorAll("[data-block-id]")),
            this.productBundleBlocks.forEach((e) => e.addEventListener("mouseenter", this.handleBlockHover.bind(this, "enter"))),
            this.productBundleBlocks.forEach((e) => e.addEventListener("mouseleave", this.handleBlockHover.bind(this, "leave")));
    }
    handleBlockHover(e, t) {
        "enter" === e ? (this.classList.add(this.cssClasses.hover), this.toggleBlockActive(t.target, !0)) : (this.classList.remove(this.cssClasses.hover), this.toggleBlockActive(null, !1));
    }
    toggleBlockActive(e, t) {
        this.productBundleBlocks.forEach((t) => {
            e && t.dataset.blockId === e.dataset.blockId ? t.classList.add(this.cssClasses.active) : t.classList.remove(this.cssClasses.active);
        });
    }
    handleButtonClick(e) {
        e.preventDefault(), (this.lastClickedElement = e.submitter || e.currentTarget);
        let t = this.querySelectorAll('[name="id"]'),
            i = { items: [...t].map((e) => e.value).map((e) => ({ id: e, quantity: 1 })) };
        if (document.body.classList.contains("cart-template") || "drawer" != FoxTheme.settings.cartType) {
            FoxTheme.utils.postLink(FoxTheme.routes.cart_add_url, { parameters: { ...i } });
            return;
        }
        this.showErrorMessage(), this.toggleButtonLoading(!0);
        let s = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:grouped-sections", { bubbles: !0, detail: { sections: s } }));
        let a = JSON.stringify({ ...i, sections: s, section_url: window.pathname });
        fetch(`${FoxTheme.routes.cart_add_url}`, { ...FoxTheme.utils.fetchConfig("javascript"), body: a })
            .then((e) => e.json())
            .then(async (e) => {
                if (e.status) {
                    this.showErrorMessage(e.description);
                    return;
                }
                if (422 === e.status) document.dispatchEvent(new CustomEvent("product-ajax:error", { detail: { errorMessage: e.description } }));
                else {
                    let t = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
                    (t.sections = e.sections),
                        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: t }),
                        document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: e } })),
                        this.cartDrawerElement && this.cartDrawerElement.show(this.lastClickedElement);
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                this.toggleButtonLoading(!1);
            });
    }
    showErrorMessage(e = !1) {
        (this.errorMessageElement = this.errorMessageElement || this.querySelector(".product-form__error-message")),
            this.errorMessageElement ? ((this.errorMessageElement.hidden = !e), e && (this.errorMessageElement.textContent = e)) : e && alert(e);
    }
    toggleButtonLoading(e) {
        e
            ? (this.addToCartButtonElement.classList.add("btn--loading"), this.addToCartButtonElement.setAttribute("disabled", !0))
            : (this.addToCartButtonElement.classList.remove("btn--loading"), this.addToCartButtonElement.removeAttribute("disabled"));
    }
}
customElements.define("products-bundle", ProductsBundle);
class ProductRecentlyViewed extends HTMLElement {
    constructor() {
        if ((super(), FoxTheme.config.hasLocalStorage)) {
            let e = parseInt(this.dataset.productId),
                t = "sleektheme:recently-viewed",
                i = JSON.parse(window.localStorage.getItem(t) || "[]");
            i.includes(e) && i.splice(i.indexOf(e), 1), i.unshift(e), window.localStorage.setItem(t, JSON.stringify(i.slice(0, 20)));
        }
    }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);
class MotionElement extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        FoxTheme.config.motionReduced ||
            (this.preInitialize(),
            FoxTheme.Motion.inView(
                this,
                async () => {
                    !this.isInstant && this.media && (await FoxTheme.utils.imageReady(this.media)), this.initialize();
                },
                { margin: "0px 0px -50px 0px" }
            ));
    }
    get isHold() {
        return this.hasAttribute("hold");
    }
    get isInstant() {
        return this.hasAttribute("data-instantly");
    }
    get mediaElements() {
        return Array.from(this.querySelectorAll("img, iframe, svg"));
    }
    get animationType() {
        return this.dataset.motion || "fade-up";
    }
    get animationDelay() {
        return parseInt(this.dataset.motionDelay || 0) / 1e3;
    }
    preInitialize() {
        if (!this.isHold)
            switch (this.animationType) {
                case "fade-in":
                    FoxTheme.Motion.animate(this, { opacity: 0.01 }, { duration: 0 });
                    break;
                case "fade-up":
                    FoxTheme.Motion.animate(this, { transform: "translateY(2.5rem)", opacity: 0.01 }, { duration: 0 });
                    break;
                case "zoom-in":
                    FoxTheme.Motion.animate(this, { transform: "scale(0.8)" }, { duration: 0 });
                    break;
                case "zoom-in-lg":
                    FoxTheme.Motion.animate(this, { transform: "scale(0)" }, { duration: 0 });
                    break;
                case "zoom-out":
                    FoxTheme.Motion.animate(this, { transform: "scale(1.3)" }, { duration: 0 });
                    break;
                case "zoom-out-sm":
                    FoxTheme.Motion.animate(this, { transform: "scale(1.1)" }, { duration: 0 });
            }
    }
    async initialize() {
        if (!this.isHold)
            switch (this.animationType) {
                case "fade-in":
                    await FoxTheme.Motion.animate(this, { opacity: 1 }, { duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished;
                    break;
                case "fade-up":
                    await FoxTheme.Motion.animate(this, { transform: "translateY(0)", opacity: 1 }, { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished;
                    break;
                case "zoom-in":
                    await FoxTheme.Motion.animate(this, { transform: "scale(1)" }, { duration: 1.3, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished;
                    break;
                case "zoom-in-lg":
                    await FoxTheme.Motion.animate(this, { transform: "scale(1)" }, { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished;
                    break;
                case "zoom-out":
                    await FoxTheme.Motion.animate(this, { transform: "scale(1)" }, { duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished;
                    break;
                case "zoom-out-sm":
                    await FoxTheme.Motion.animate(this, { transform: "scale(1)" }, { duration: 1, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished;
            }
    }
    async resetAnimation(e) {
        switch (this.animationType) {
            case "fade-in":
                await FoxTheme.Motion.animate(this, { opacity: 0 }, { duration: e || 1.5, delay: this.animationDelay, easing: e ? "none" : [0, 0, 0.3, 1] }).finished;
                break;
            case "fade-up":
                await FoxTheme.Motion.animate(this, { transform: "translateY(2.5rem)", opacity: 0 }, { duration: e || 0.5, delay: this.animationDelay, easing: e ? "none" : [0, 0, 0.3, 1] }).finished;
                break;
            case "zoom-in":
            case "zoom-in-lg":
                await FoxTheme.Motion.animate(this, { transform: "scale(0)" }, { duration: e || 1.3, delay: this.animationDelay, easing: e ? "none" : [0, 0, 0.3, 1] }).finished;
                break;
            case "zoom-out":
            case "zoom-out-sm":
                await FoxTheme.Motion.animate(this, { transform: "scale(0)" }, { duration: e || 1.3, delay: this.animationDelay, easing: e ? "none" : [0.16, 1, 0.3, 1] }).finished;
        }
    }
    refreshAnimation() {
        this.removeAttribute("hold"),
            this.preInitialize(),
            setTimeout(() => {
                this.initialize();
            }, 50);
    }
}
customElements.define("motion-element", MotionElement);
class TabsComponent extends HTMLElement {
    constructor() {
        super(),
            (this.selectors = { tabHeader: '[role="tablist"]', tabPanels: ['[role="tabpanel"]'], tabNavs: ['[role="tab"]'], tabSelect: "tab-selector" }),
            (this.domNodes = FoxTheme.utils.queryDomNodes(this.selectors, this)),
            (this.selectedIndex = 0),
            (this.selectedTab = this.domNodes.tabPanels[this.selectedIndex]),
            (this.scrollToActiveTab = "true" === this.dataset.scrollToActiveTab),
            (this.scrollOffset = 20),
            (this.headerEl = document.querySelector('.header-section header[is="sticky-header"]')),
            this.init(),
            this.setActiveTab(0),
            (this.tabChange = new CustomEvent("tabChange", { bubbles: !0, detail: { selectedTab: this.selectedTab } }));
    }
    connectedCallback() {
        this.setActiveTab(0);
    }
    init = () => {
        this.domNodes.tabNavs.forEach((e) => {
            e.addEventListener("click", this.onTabClick.bind(this));
        }),
            this.domNodes.tabHeader && this.domNodes.tabHeader.addEventListener("keydown", this.handleKeyDown.bind(this)),
            this.setAccessible();
    };
    static get observedAttributes() {
        return ["data-selected"];
    }
    get buttons() {
        return (this._buttons = this._buttons || Array.from(this.querySelectorAll('button[role="tab"]')));
    }
    getHeaderHeight() {
        let e = 0;
        if (this.headerEl) {
            let t = Math.round(this.headerEl.offsetHeight);
            if (this.headerEl.isAlwaysSticky) e = t;
            else {
                let i = document.body.classList.contains(this.headerEl.classes.pinned);
                window.scrollY > this.offsetTop - this.scrollOffset && (e = t), i && window.scrollY >= this.offsetTop - this.scrollOffset - t && (e = t);
            }
        }
        return e;
    }
    scrollToTop() {
        let e = this.offsetTop - this.scrollOffset - this.getHeaderHeight();
        window.scrollTo({ top: e, behavior: "smooth" });
    }
    onTabClick(e) {
        e.preventDefault();
        let t = e.currentTarget,
            i = t ? Number(t.dataset.index) : 0;
        this.setActiveTab(i), this.scrollToActiveTab && this.scrollToTop();
    }
    setActiveTab = (e) => {
        let { tabNavs: t, tabPanels: i, tabSelect: s } = this.domNodes;
        if (-1 !== e) {
            let a = t && t[e],
                n = i && i[e];
            this.setAttribute("data-selected", e),
                t.forEach((e) => e.setAttribute("aria-selected", !1)),
                a && a.setAttribute("aria-selected", !0),
                (this.selectedIndex = e),
                (this.selectedTab = n),
                this.dispatchEvent(new CustomEvent("tabChange", { bubbles: !0, detail: { selectedIndex: e, selectedTab: n } })),
                s && (s.querySelector("select").value = e);
        }
    };
    setAccessible() {
        let { tabNavs: e, tabPanels: t } = this.domNodes;
        e.forEach((e, i) => {
            e.id && t[i].setAttribute("aria-labelledby", e.id), e.setAttribute("aria-selected", 0 === i), e.setAttribute("data-index", i);
        }),
            t.forEach((t, i) => {
                t.id && e[i].setAttribute("aria-controls", t.id), t.setAttribute("tabindex", 0);
            });
    }
    handleKeyDown(e) {
        let { tabNavs: t } = this.domNodes;
        (39 === e.keyCode || 37 === e.keyCode) &&
            (t[this.selectedIndex].setAttribute("tabindex", -1),
            39 === e.keyCode ? (this.selectedIndex++, this.selectedIndex >= t.length && (this.selectedIndex = 0)) : 37 === e.keyCode && (this.selectedIndex--, this.selectedIndex < 0 && (this.selectedIndex = t.length - 1)),
            t[this.selectedIndex].setAttribute("tabindex", 0),
            t[this.selectedIndex].focus());
    }
    getSelected() {
        return { index: this.selectedIndex, element: this.selectedTab };
    }
    attributeChangedCallback(e, t, i) {
        if ("data-selected" === e && null !== t && t !== i) {
            let s = this.buttons[parseInt(t)],
                a = this.buttons[parseInt(i)];
            this.transition(document.getElementById(s.getAttribute("aria-controls")), document.getElementById(a.getAttribute("aria-controls")));
        }
    }
    async transition(e, t) {
        await FoxTheme.Motion.animate(e, { transform: ["translateY(0)", "translateY(2rem)"], opacity: [1, 0] }, { duration: 0.3 }).finished,
            (e.hidden = !0),
            (t.hidden = !1),
            FoxTheme.Motion.animate(t, { transform: ["translateY(2rem)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.3 }).finished,
            t.querySelector("grid-list") && t.querySelector("grid-list").showGridItems();
    }
}
customElements.define("tabs-component", TabsComponent);
class TabSelector extends HTMLElement {
    constructor() {
        super(),
            (this.tabs = this.closest("tabs-component")),
            this.querySelector("select").addEventListener("change", (e) => {
                this.tabs.setActiveTab(e.target.value);
            });
    }
}
customElements.define("tab-selector", TabSelector);
class Parallax extends HTMLElement {
    get parallax() {
        return !!this.dataset.parallax && parseFloat(this.dataset.parallax);
    }
    get parallaxDirection() {
        return this.dataset.parallaxDirection || "vertical";
    }
    get parallaxMediaElements() {
        return Array.from(this.querySelectorAll("img, video, iframe, svg, video-element"));
    }
    connectedCallback() {
        this.shouldInitializeParallax() && this.setupParallax();
    }
    shouldInitializeParallax() {
        return !FoxTheme.config.motionReduced && this.parallax;
    }
    setupParallax() {
        let e = 1 + this.parallax,
            t = (100 * this.parallax) / (1 + this.parallax),
            i = {};
        (i =
            "vertical" === this.parallaxDirection
                ? { transform: [`scale(${e}) translateY(0)`, `scale(${e}) translateY(${t}%)`], transformOrigin: ["bottom", "bottom"] }
                : "horizontal" === this.parallaxDirection
                ? { transform: [`scale(${e}) translateX(0)`, `scale(${e}) translateX(${t}%)`], transformOrigin: ["right", "right"] }
                : { transform: ["scale(1)", `scale(${e})`], transformOrigin: ["center", "center"] }),
            FoxTheme.Motion.scroll(FoxTheme.Motion.animate(this.parallaxMediaElements, i, { easing: "linear" }), { target: this, offset: ["start end", "end start"] });
    }
}
customElements.define("parallax-element", Parallax);
class ProductForm extends HTMLFormElement {
    constructor() {
        super(), (this.productIdInput = this.querySelector("[name=id]")), (this.productIdInput.disabled = !1), this.addEventListener("submit", this.handleFormSubmit);
    }
    get cartDrawerElement() {
        return document.querySelector("cart-drawer");
    }
    get submitButtonElement() {
        return (this._submitButtonElement = this._submitButtonElement || this.querySelector('[type="submit"]'));
    }
    get isHideErrors() {
        return "true" === this.dataset.hideErrors;
    }
    handleFormSubmit = (e) => {
        if (document.body.classList.contains("cart-template") || "page" === FoxTheme.settings.cartType || (e.preventDefault(), this.submitButtonElement.hasAttribute("aria-disabled"))) return;
        (this.lastSubmittedElement = e.submitter || e.currentTarget), this.displayFormErrors();
        let t = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:grouped-sections", { bubbles: !0, detail: { sections: t } }));
        let i = FoxTheme.utils.fetchConfig("javascript");
        (i.headers["X-Requested-With"] = "XMLHttpRequest"),
            delete i.headers["Content-Type"],
            (this.formData = new FormData(this)),
            this.formData.append("sections", t),
            this.formData.append("sections_url", window.location.pathname),
            (i.body = this.formData),
            this.submitButtonElement.setAttribute("aria-disabled", "true"),
            this.submitButtonElement.classList.add("btn--loading"),
            this.handleFormSubmission(i);
    };
    displayFormErrors = (e = !1) => {
        this.isHideErrors ||
            ((this.formErrorMessage = this.formErrorMessage || this.querySelector(".product-form__error-message")),
            this.formErrorMessage ? (this.formErrorMessage.toggleAttribute("hidden", !e), (this.formErrorMessage.innerText = e)) : !1 !== e && alert(e));
    };
    handleFormSubmission = (e) => {
        fetch(`${FoxTheme.routes.cart_add_url}`, e)
            .then((e) => e.json())
            .then(async (e) => {
                if (e.status) {
                    this.handleCartError(e);
                    return;
                }
                let t = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
                (t.sections = e.sections), this.updateCartState(t), this.dispatchProductAddedEvent(e), this.showCartDrawer();
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                this.submitButtonElement.classList.remove("btn--loading"), this.submitButtonElement.removeAttribute("aria-disabled"), this.hasError || this.submitButtonElement.removeAttribute("aria-disabled");
            });
    };
    handleCartError = (e) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, { source: "product-form", productVariantId: this.formData.get("id"), errors: e.errors || e.description, message: e.message }),
            this.displayFormErrors(e.description),
            document.dispatchEvent(new CustomEvent("product-ajax:error", { detail: { errorMessage: e.description } })),
            (this.hasError = !0);
    };
    updateCartState = (e) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: e });
    };
    dispatchProductAddedEvent = (e) => {
        document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: e } }));
    };
    showCartDrawer = () => {
        let e = this.closest("quick-view-modal");
        e
            ? (this.cartDrawerElement &&
                  !this.cartDrawerElement.open &&
                  document.body.addEventListener(
                      e.events.handleAfterHide,
                      () => {
                          setTimeout(() => {
                              this.cartDrawerElement.show(this.lastSubmittedElement);
                          });
                      },
                      { once: !0 }
                  ),
              e.hide(!0))
            : this.cartDrawerElement && this.cartDrawerElement.show(this.lastSubmittedElement);
    };
}
customElements.define("product-form", ProductForm, { extends: "form" });
class HighlightText extends HTMLElement {
    constructor() {
        super(), FoxTheme.Motion.inView(this, this.init.bind(this));
    }
    init() {
        this.classList.add("animate");
    }
}
customElements.define("highlight-text", HighlightText, { extends: "em" });
class NewsletterForm extends HTMLFormElement {
    constructor() {
        super(), (this.selectors = { subscribedMessage: "[id*=Newsletter-error-subscribed]", modal: "[id*=NewsletterAlertModal-]" }), this.init();
    }
    init() {
        let e = window.location.href,
            t = e.includes("form_type=customer"),
            i = this.querySelector('[id*="NewsletterForm"]').value.length,
            s = this.querySelector(this.selectors.modal);
        if (t && 0 != i) {
            let a = this.querySelector(this.selectors.subscribedMessage);
            a && a.classList.remove("hidden"), window.isNewsletterModalShow || (s && s.show(), (window.isNewsletterModalShow = !0));
        }
        let n = this.querySelector(".form-message--main");
        n && !window.isNewsletterModalShow && (s && s.show(), (window.isNewsletterModalShow = !0));
    }
}
function initConcernTabs() {
    let e = document.querySelectorAll(".tab-button"),
        t = document.querySelectorAll(".tab-content");
    e.length &&
        t.length &&
        e.forEach((i) => {
            i.addEventListener("click", () => {
                let s = i.getAttribute("data-tab");
                e.forEach((e) => e.classList.remove("active")),
                    i.classList.add("active"),
                    t.forEach((e) => {
                        e.style.display = e.getAttribute("data-tab") === s ? "block" : "none";
                    });
            });
        });
}
customElements.define("newsletter-form", NewsletterForm, { extends: "form" }), document.addEventListener("DOMContentLoaded", initConcernTabs), document.addEventListener("shopify:section:load", initConcernTabs);
